import script from "./ThemeToggle.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemeToggle.vue?vue&type=script&setup=true&lang=js"

import "./ThemeToggle.vue?vue&type=style&index=0&id=2e358706&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e358706"]])

export default __exports__